import script from "./VocabularyLibrary.vue?vue&type=script&setup=true&lang=ts"
export * from "./VocabularyLibrary.vue?vue&type=script&setup=true&lang=ts"

import "./VocabularyLibrary.vue?vue&type=style&index=0&id=40843eed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40843eed"]])

export default __exports__